export default "__VITE_ASSET__33b23686__"